import { Card, MatchCase } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Text, useMedia, View } from "tamagui";

import { api } from "~/utils/api";
import { WithTutorial } from "~/component/blocks";
import { Howareu } from "~/component/blocks/howareu";
import {
  CallToDoHooks,
  RecommendationMobile,
  Recommendations,
  Tasks,
} from "~/component/feature";
import { CallToDoctor } from "~/component/feature/home/call-to-doctor";
import { Header, MainLayout } from "~/component/layout";
import { useConstructRecommendations, useMe } from "~/hooks";
import { useTrackOnce } from "~/hooks/use-track";

const Home = () => {
  useTrackOnce("Render Homepage");
  const { t } = useTranslation("homePage");
  const { sm } = useMedia();

  const { data } = api.home.getHomeInfo.useQuery();
  const { recommendations } = data ?? {};

  const formatedRecommendations = useConstructRecommendations(recommendations);
  const person = useMe();

  const greeting = data?.diagnosticStatus
    ? t("welcome_returning_message", {
        name: person.name,
      })
    : t("welcome_message", { name: person.name });

  const description = data?.diagnosticStatus
    ? t("description_returning")
    : t("description");

  return (
    <WithTutorial header={<Header isTutorial />}>
      <MainLayout>
        <CallToDoctor />
        <CallToDoHooks />

        <Card
          width={"100%"}
          gap={"$5"}
          shadow={"none"}
          variant={"borderless"}
          size={"sm"}
          $gtSm={{ shadow: "md", variant: "default", size: "md" }}
        >
          <View
            gap={"$1"}
            justifyContent="center"
            alignSelf="center"
            flex={1}
            $sm={{ gap: "$1.5" }}
          >
            <Card.Title
              data-id="home-page-greeting"
              $sm={{ fontSize: "$6", lineHeight: "$6" }}
              fontSize={"$7"}
              lineHeight={"$7"}
            >
              {greeting}
            </Card.Title>
            <Card.Subtitle
              data-id={"home-page-descrition"}
              textAlign="center"
              color="$gray-800"
            >
              {description}
            </Card.Subtitle>
          </View>

          <Tasks />
        </Card>

        {/* {prevResultsHasScore(rest) && (
          <PreviousResults data={rest as PreviousResultsData} />
        )} */}
        {formatedRecommendations && formatedRecommendations.length > 0 && (
          <Card
            data-id="home-recommendations"
            gap={"$5"}
            shadow={"none"}
            variant={"borderless"}
            size={"sm"}
            width={"100%"}
            $gtMd={{ shadow: "md", variant: "default", size: "md" }}
          >
            <View gap={"$1"}>
              <Card.Title data-id="recommendations-title">
                {t("recommendations.title")}
              </Card.Title>
              <Text
                data-id="recommendations-description"
                fontFamily={"$body"}
                fontWeight={"$5"}
                fontSize={"$5"}
                lineHeight={"$5"}
                textAlign={"center"}
                color={"$gray-650"}
                $sm={{ fontSize: "$2", lineHeight: "$2" }}
              >
                {t("recommendations.description")}
              </Text>
            </View>

            <MatchCase value={sm}>
              {(Case) => (
                <>
                  <Case condition={false}>
                    <Recommendations data={formatedRecommendations} />
                  </Case>

                  <Case condition={true}>
                    <RecommendationMobile data={formatedRecommendations} />
                  </Case>
                </>
              )}
            </MatchCase>
          </Card>
        )}
        <View width="100%" $sm={{ paddingHorizontal: "$3", paddingTop: "$4" }}>
          <Howareu />
        </View>
      </MainLayout>
    </WithTutorial>
  );
};

export default Home;
